import { useMemo } from "react";
import type { PlacementSlotKey } from "@/cms/lib/placements";
import { useQuery } from "@tanstack/react-query";

type PlacementRenderResponse = {
  placement: {
    id: string;
    slot: PlacementSlotKey;
    categoryId: string | null;
  } | null;
  items: Array<{
    placementId: string | null;
    contentId: string;
    sortOrder: number;
    viewMode: "list" | "card" | "carousel" | "previewCard";
    blocks: any[];
    content: any;
  }>;
};

type UsePlacementContentArgs = {
  slot: PlacementSlotKey;
  locale: "en" | "fa";
  categoryId?: string | null;
  enabled?: boolean;
};

export function usePlacementContent({
  slot,
  locale,
  categoryId,
  enabled = true,
}: UsePlacementContentArgs) {
  const key = useMemo(
    () => `placement:${slot}:${categoryId ?? "global"}:${locale}`,
    [slot, categoryId, locale],
  );

  const query = useQuery<PlacementRenderResponse>({
    queryKey: [key],
    queryFn: async () => {
      const params = new URLSearchParams({
        slot,
        locale,
      });
      if (categoryId) params.set("categoryId", categoryId);
      const res = await fetch(
        `/api/cms/placements/render?${params.toString()}`,
      );
      if (!res.ok) {
        throw new Error(`Failed to load placement: ${res.status}`);
      }
      return res.json();
    },
    enabled
  });

  // const query = useQuery<PlacementRenderResponse>(
  //   key,
  //   async () => {
  //     const params = new URLSearchParams({
  //       slot,
  //       locale,
  //     });
  //     if (categoryId) params.set("categoryId", categoryId);
  //     const res = await fetch(
  //       `/api/cms/placements/render?${params.toString()}`,
  //     );
  //     if (!res.ok) {
  //       throw new Error(`Failed to load placement: ${res.status}`);
  //     }
  //     return res.json();
  //   },
  //   { autoFetch: enabled, cacheTime: 0 },
  // );

  return query;
}
